module.exports = __webpack_public_path__ + "static/media/Credits-37.3e49ff7d.pdf";